import { commonConstants } from "../_constants";

export const imageUploadRequest = (payload) => {
    return {
        type: commonConstants.IMAGE_UPLOAD_REQUEST,
        payload,
    };
};

export const imageUploadComplete = (payload) => {
    return {
        type: commonConstants.IMAGE_UPLOAD_COMPLETE,
        payload,
    };
};

export const imageUploadError = (payload) => {
    return {
        type: commonConstants.IMAGE_UPLOAD_ERROR,
        payload,
    };
};

export const imageUploadClear = () => {
    return {
        type: commonConstants.IMAGE_UPLOAD_CLEAR,
    };
};
